import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  model,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CompanyInterface } from '@app/interface/company';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-confirm-progressive-number-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  standalone: true,
  templateUrl: './confirm-progressive-number-dialog.component.html',
  styleUrl: './confirm-progressive-number-dialog.component.scss',
})
export class ConfirmProgressiveNumberDialogComponent {
  confirmed = false;
  progressive_number: number = 0;
  healthcare_invoice: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmProgressiveNumberDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      progressive_number: number;
      healthcare_invoice: boolean;
    }
  ) {
    this.progressive_number = data.progressive_number;
    this.healthcare_invoice = data.healthcare_invoice;
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
